package br.com.texeratx.boardgametimeapp.core.theme

import br.com.texeratx.boardgametimeapp.core.storage.ThemeStorage
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class ThemeManager(
    private val storage: ThemeStorage
) {
    private val _theme = MutableStateFlow(AppThemeMode.DEFAULT)
    val theme: StateFlow<AppThemeMode> = _theme.asStateFlow()

    suspend fun init() {
        val saved = storage.getTheme()
        if (saved != null) {
            _theme.value = saved
        }
    }

    suspend fun setTheme(mode: AppThemeMode) {
        storage.saveTheme(mode)
        _theme.value = mode
    }
}
